module.exports = require("./mgh-MZ.js");